import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgDevelopment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 65,
	height: 65,
	viewBox: "0 0 65 65",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.389 17.1385C10.7939 17.237 13.05 22.4565 13.05 23.6382V27.282V39.8876C13.05 41.8572 15.276 42.9405 16.389 43.2359C16.8703 43.4329 18.573 43.7086 21.533 43.2359C25.233 42.645 47.9746 43.9253 50.7722 43.8268C53.5697 43.7283 55.0137 42.645 56.2771 41.6602C57.5405 40.6754 56.4576 25.1155 56.2771 20.9793C56.0966 16.8431 54.021 17.1385 52.2161 17.1385H44.6356C40.9355 17.1385 21.9842 17.04 16.389 17.1385Z",
			fill: "#E2E2E4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.0714 21.6885C33.3741 28.2277 32.6552 29.3468 30.5249 38.5951",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.85513 43.2324C9.85513 41.2702 10.5119 33.1208 10.1835 27.1843C9.92081 22.435 10.1835 18.6574 10.1835 17.5048C10.1835 16.3522 9.95687 14.353 12.936 14.2667C16.6598 14.1587 30.607 14.5905 39.8896 14.2667C47.3157 14.0076 50.9803 14.1885 52.2036 14.2964C53.283 14.3684 55.431 15.1168 55.3878 17.5346C55.3338 20.5568 55.8469 25.1826 55.3878 31.2641C55.1668 34.1917 55.3878 42.3952 55.3878 43.2622M9.85513 43.2324C10.1636 43.2324 13.4448 43.0395 21.3244 43.2622C29.204 43.4849 33.8149 43.5553 41.6912 43.2622C49.5675 42.969 49.4512 43.4095 55.3878 43.2622M9.85513 43.2324C8.4175 43.139 5.7635 43.2099 5.78134 44.8412C5.79918 46.4724 7.07663 51.5478 9.07348 51.7097C11.0703 51.8716 26.4369 51.9252 30.7005 51.9252C34.964 51.9252 50.0361 52.0332 51.4933 51.9252C52.9504 51.8173 56.6915 51.842 57.3568 51.3014C58.0222 50.7608 59.9687 48.445 60.0214 45.286C60.074 42.1269 57.1138 43.2622 55.3878 43.2622",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.0339 47.7725C32.4024 47.7725 33.2469 47.7725 33.6231 47.7725",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.8786 24.624C25.5597 24.6963 19.7379 28.3838 19.8127 29.8236C19.8876 31.2633 25.081 34.9764 25.4798 34.9764",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.5431 24.71C40.8359 24.7779 46.2075 27.6062 46.3163 29.1929C46.4251 30.7795 40.9098 34.9767 40.5435 34.9767",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDevelopment;
